// extracted by mini-css-extract-plugin
module.exports = {"left":"idt-buttonwithicon_left__1w_gg","right":"idt-buttonwithicon_right__kdq8c"};